import { config } from "@/config";
export class PedidoService {
    // Confirmar la orden (crea pedido + detalle + confirmación vendedor)
    static async confirmarOrden(dto) {
        const response = await fetch(`${config.API_URL}/api/Pedido/confirmar-orden`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(dto),
        });
        if (!response.ok) {
            throw new Error("Error al confirmar la orden");
        }
        return response.json();
    }
    // Confirmar producto por parte del vendedor
    static async confirmarProducto(dto) {
        const response = await fetch(`${config.API_URL}/api/Pedido/confirmar-producto`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(dto),
        });
        if (!response.ok) {
            throw new Error("Error al confirmar el producto");
        }
        return response.json();
    }
    // Obtener un pedido por ID
    static async getPedidoById(pedidoId) {
        const response = await fetch(`${config.API_URL}/api/Pedido/${pedidoId}`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                "Content-Type": "application/json",
            },
        });
        if (!response.ok) {
            throw new Error("Error al obtener el pedido");
        }
        return response.json();
    }
    // Obtener todas las confirmaciones del vendedor
    static async getConfirmacionesVendedor() {
        const response = await fetch(`${config.API_URL}/api/Pedido/confirmaciones`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                "Content-Type": "application/json",
            },
        });
        if (!response.ok) {
            throw new Error("Error al obtener las confirmaciones del vendedor");
        }
        return response.json();
    }
    // Obtener todas las confirmaciones del comprador
    static async confirmacionesComprador() {
        const response = await fetch(`${config.API_URL}/api/Pedido/confirmacionesComprador`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                "Content-Type": "application/json",
            },
        });
        if (!response.ok) {
            throw new Error("Error al obtener las confirmaciones del comprador");
        }
        return response.json();
    }
    // Obtener todos los pedidos (solo para administradores)
    static async getTodosPedidos() {
        const response = await fetch(`${config.API_URL}/api/Pedido/todos`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                "Content-Type": "application/json",
            },
        });
        if (!response.ok) {
            throw new Error("Error al obtener todos los pedidos");
        }
        return response.json();
    }
}
